<template>
  <div class="demand-label">
    <span v-if="isUnlocked" class="demand-label__unlocked">
      {{ $t("ETAB.PAGES.RECRUITMENT.TILE.@UNLIMITED_CONTACT") }}
    </span>
    <span v-else>
      {{ $t("ETAB.PAGES.RECRUITMENT.TILE.@NO_UNLIMITED_CONTACT") }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    isUnlocked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
